import "./share.css";
import PermMedia from "@mui/icons-material/PermMedia";
import Label from "@mui/icons-material/Label";
import EmojiEmotions from "@mui/icons-material/EmojiEmotions";
import Cancel from "@mui/icons-material/Cancel";
import Close from "@mui/icons-material/Close";
import { useContext, useRef, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";

export default function Share() {
  const { user } = useContext(AuthContext);
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const desc = useRef();
  const tagText = useRef();
  const [file, setFile] = useState(null);
  const [fileBase64, setFileBase64] = useState("");
  const [tags, setTags] = useState([]);
  const [haveTags, setHaveTags] = useState(false);

  const createTag = (event) => {
    if (event.key === "Enter") {
      try {
        const tagTextReplaced = tagText.current.value.replace(/ /g, "_");
        if (tagTextReplaced.length > 30) throw "Too many letters for a tag";
        if (tagTextReplaced.length === 0) throw "Cannot make a empty tag";
        if (tags.length > 9) throw "You are only allowed to create 10 tags per post";

        const newTags = [...tags, tagTextReplaced];
        tagText.current.value = "";
        setTags(newTags);
      } catch (err) {
        alert(err);
      }
    }
  };

  const removeTag = (idx) => {
    setTags([...tags.filter((_, index) => index !== idx)]);
  };

  const imageUpload = (e) => {
    setFile(e.target.files[0])
    let file = document.querySelector('input[type=file]')['files'][0];
    var reader = new FileReader();
    reader.onload = function() {
      setFileBase64(reader.result);
    };

    reader.readAsDataURL(file);
  }
 
  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      var newPost = {
        userId: user._id,
        desc: desc.current.value,
        tags: tags,
        img: fileBase64,
      };
      await axios.post("https://conexus-api.vercel.app/api/posts", newPost);
      window.location.reload();
    } catch (err) {
      alert("Error sharing post")
    }
  };

  return (
    <div className="share">
      <div className="shareWrapper">
        <div className="shareTop">
          <img
            className="shareProfileImg"
            src={
              user.profilePicture
                ? PF + "person/" + user.profilePicture
                : PF + "person/no-avatar.png"
            }
            alt=""
          />
          <input
            placeholder={`What's in your mind ${user.username}?`}
            ref={desc}
            className="shareInput"
          />
        </div>
        <div className="shareTags">
          {tags.map((tag, idx) => (
            <div className="shareTag" key={idx}>
              <span>{tag}</span>
              <Close htmlColor="#363636" onClick={() => removeTag(idx)} />
            </div>
          ))}
        </div>
        {haveTags && (
          <input
            type="text"
            ref={tagText}
            onKeyDown={createTag}
            className="shareTagInput"
            placeholder="Write some tags"
          />
        )}
        <hr className="shareHr" />
        {file && (
          <div className="shareImgContainer">
            <img className="shareImg" src={URL.createObjectURL(file)} alt="" />
            <Cancel className="shareCancelImg" onClick={() => setFile(null)} />
          </div>
        )}
        <form className="shareBottom">
          <div className="shareOptions">
            <label htmlFor="fileInput" className="shareOption">
              <PermMedia htmlColor="#00ffc3" className="shareIcon" />
              <span className="shareOptionText">Media</span>
              <input
                onChange={imageUpload}
                style={{ display: "none" }}
                accept=".png,.jpeg,.jpg,.mp4"
                type="file"
                id="fileInput"
                name="fileInput"
              />
            </label>
            <div
              className="shareOption"
              onClick={() => {
                setHaveTags((x) => !x);
              }}
            >
              <Label htmlColor="#00BFFF" className="shareIcon" />
              <span className="shareOptionText">Tag</span>
            </div>
            <div className="shareOption">
              <EmojiEmotions htmlColor="#ffd700" className="shareIcon" />
              <span className="shareOptionText">Feelings</span>
            </div>
          </div>
          <button onClick={submitHandler} className="shareButton">
            Share
          </button>
        </form>
      </div>
    </div>
  );
}
